// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ApproveDenyButtonGroup from './approve-deny-button-group';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';

const SecureFooter = (props, context) => hasAccess(context.security, props.securityModule, props.securityFeature) &&
    <footer>
        <ApproveDenyButtonGroup
            isShowReturnButton={props.isShowReturnButton}
            onApprove={props.onApprove}
            onDeny={props.onDeny}
            onReturn={props.onReturn}
        />
    </footer>;

SecureFooter.displayName = 'SecureFooter';
SecureFooter.propTypes = {
    onApprove: PropTypes.func.isRequired,
    onDeny: PropTypes.func.isRequired,
    securityFeature: PropTypes.string,
    securityModule: PropTypes.string.isRequired
};
SecureFooter.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};
SecureFooter.defaultProps = {
    isShowReturnButton: false,
    onReturn: null
};
export default SecureFooter;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/secure-footer.js